<template>
	<div>
		<div class="price-table--feature-content-price-inner">
			<template v-if="getUpgradableItem(product)">
				<div class="price-table--feature-content-price-title">
					<span>&euro;</span>{{ formatPrice(getUpgradableItem(product).netAmountToPayFormatted) }}
				</div>
				<div class="price-table--feature-content-price-info mb-3">
					Upgrade-Preis
				</div>
			</template>
			<div v-if="!getUpgradableItem(product)" class="price-table--feature-content-price-title">
				<span>&euro;</span>{{ formatPrice(product.netAmountFormatted) }}
			</div>
			<div v-if="getUpgradableItem(product)" class="price-table--feature-content-price-info">
				<div>Monatliche Verlängerung:</div>
				<div><b>{{ product.netAmountFormatted | moneyAmount }}</b></div>
			</div>
			<div v-else class="price-table--feature-content-price-info">
				pro Monat.<br/>Jederzeit kündbar.
			</div>
		</div>
		<div v-if="customButtonClickHandler || !isLoggedIn" class="price-table--feature-content-price-button">
			<div class="price-table--feature-content-price-buy">
				<template v-if="customersCurrentProductId === product.id">
					Aktuell
				</template>
				<template v-if="chosenProduct && chosenProduct.id === product.id">
					<Icon icon="checkmark" color="green"/>
				</template>
				<template v-else-if="authLoaded && isShowBuyButton(product)">
					<Button
						:text="buyButtonText"
						@click="handleButtonClick(product)"
					/>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import Icon from "@/vue/icon/Icon.vue";
import Button from "@/vue/common/Button.vue";
import {mapGetters, mapState} from "vuex";
import * as MoneyUtil from "@/helper/util/Money";
import {arrayIsNotEmpty} from "@/helper/Array";
import {isDefined} from "@/helper/Value";

export default {
	components: {Icon, Button},

	props: {
		product: {
			type: Object,
			required: false
		},
		customButtonClickHandler: {
			type: Boolean,
			required: false,
			default: false,
		},
		chosenProduct: {
			type: Object,
			required: false
		},
		upgradableItems: {
			type: Array,
			required: false
		}
	},

	computed: {
		...mapState('auth', {
			'authLoaded': 'loaded',
			'customer': 'customer'
		}),
		...mapGetters('auth', ['isLoggedIn']),
		buyButtonText ()
		{
			if (this.customButtonClickHandler)
			{
				return 'Auswählen';
			}

			return this.isLoggedIn ? 'Jetzt kaufen' : 'Los geht\'s';
		},
		buyButtonLink ()
		{
			return this.isLoggedIn
				? '/kundenbereich/verrechnung?openPurchaseSubscriptionPopUp=1'
				: '/kunde/eintragung';
		},
		customersCurrentProductId ()
		{
			if (!this.customer || !this.customer.subscription?.active)
			{
				return undefined;
			}

			return this.customer.subscription?.productId;
		}
	},

	methods: {
		handleButtonClick (product)
		{
			if (this.customButtonClickHandler)
			{
				this.$emit('buy', {product});
				return;
			}

			window.location.href = this.buyButtonLink;
		},
		formatPrice (price)
		{
			return MoneyUtil.format(price, {
				withCurrency: false
			});
		},
		getUpgradableItem (product)
		{
			return _.find(
				this.upgradableItems || [],
				item => item.product.id === product.id
			);
		},
		isShowBuyButton (product)
		{
			if (arrayIsNotEmpty(this.upgradableItems))
			{
				return isDefined(this.getUpgradableItem(product));
			}

			return true;
		}
	}
}
</script>
